import { useEffect, useState } from 'react';

export const useIsMobileHook = () => {
  const [isMobileState, setIsMobileState] = useState(window.innerWidth < 640);

  useEffect(() => {
    const listener = () => {
      setIsMobileState(window.innerWidth < 640);
    };

    window.addEventListener('resize', listener);

    return () => {
      window.removeEventListener('resize', listener);
    };
  }, []);

  return isMobileState;
};
